<template>
  <div id="CreateClientsAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>Create new client</span>
            </h1>
            <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <!-- start -->
                <form @submit.prevent="handleSubmit" enctype="multipart/form-data">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Reference / Shortname</label>
                        <input
                          type="text"
                          v-model="client.ref"
                          class="form-control"
                          placeholder="e.g. UNILAG"
                          :class="{ 'is-invalid': $v.client.ref.$error, 'is-valid': !$v.client.ref.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.ref.required">Reference or shortname is required.</span>
                          <span v-if="!$v.client.ref.alphaNum">Reference or shortname is has to be alphanumerics only.</span>
                          <span v-if="!$v.client.ref.minLength"
                            >Reference or shortname must be at least {{ $v.client.ref.$params.minLength.min }} letters.</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Name</label>
                        <input
                          type="text"
                          v-model="client.name"
                          class="form-control"
                          placeholder="e.g. University of Lagos"
                          :class="{ 'is-invalid': $v.client.name.$error, 'is-valid': !$v.client.name.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.name.required">Name is required.</span>
                          <span v-if="!$v.client.name.minLength">Name must be at least {{ $v.client.name.$params.minLength.min }} letters.</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- second role -->
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">
                          Primary Color
                          <div :style="'height: 5px; width:100px; background-color:' + client.primaryColor"></div>
                        </label>
                        <input
                          type="text"
                          v-model="client.primaryColor"
                          class="form-control"
                          placeholder="#000000"
                          :class="{ 'is-invalid': $v.client.primaryColor.$error, 'is-valid': !$v.client.primaryColor.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.primaryColor.required">Primary color is required.</span>
                          <span v-if="!$v.client.primaryColor.minLength"
                            >Primary color must be at least {{ $v.client.primaryColor.$params.minLength.min }} letters.</span
                          >
                          <span v-if="!$v.client.primaryColor.maxLength"
                            >Primary color must not exceed {{ $v.client.primaryColor.$params.maxLength.max }} letters.</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">
                          Secondary Color
                          <div :style="'height: 5px; width:100px; background-color:' + client.secondaryColor"></div>
                        </label>
                        <input
                          type="text"
                          v-model="client.secondaryColor"
                          class="form-control"
                          placeholder="#000000"
                          :class="{ 'is-invalid': $v.client.secondaryColor.$error, 'is-valid': !$v.client.secondaryColor.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.secondaryColor.required">Secondary color is required.</span>
                          <span v-if="!$v.client.secondaryColor.minLength"
                            >Secondary color must be at least {{ $v.client.secondaryColor.$params.minLength.min }} letters.</span
                          >
                          <span v-if="!$v.client.secondaryColor.maxLength"
                            >Secondary color must not exceed {{ $v.client.secondaryColor.$params.maxLength.max }} letters.</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end second role -->

                  <!-- third role -->
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Top Category Label</label>
                        <input
                          type="text"
                          v-model="client.topCategoryLabel"
                          class="form-control"
                          placeholder="e.g. Faculty"
                          :class="{ 'is-invalid': $v.client.topCategoryLabel.$error, 'is-valid': !$v.client.topCategoryLabel.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.topCategoryLabel.required">Category label is required.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Subcategory Label</label>
                        <input
                          type="text"
                          v-model="client.subCategoryLabel"
                          class="form-control"
                          placeholder="e.g. Department"
                          :class="{ 'is-invalid': $v.client.subCategoryLabel.$error, 'is-valid': !$v.client.subCategoryLabel.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.subCategoryLabel.required">Subcategory label is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end third role -->

                  <!-- forth role -->
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Supervisor Label</label>
                        <input
                          type="text"
                          v-model="client.supervisorLabel"
                          class="form-control"
                          placeholder="e.g. Dean"
                          :class="{ 'is-invalid': $v.client.supervisorLabel.$error, 'is-valid': !$v.client.supervisorLabel.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.supervisorLabel.required">Supervisor label is required.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">Agent Label</label>
                        <input
                          type="text"
                          v-model="client.agentLabel"
                          class="form-control"
                          placeholder="e.g HOD"
                          :class="{ 'is-invalid': $v.client.agentLabel.$error, 'is-valid': !$v.client.agentLabel.$invalid }"
                        />
                        <div class="invalid-feedback">
                          <span v-if="!$v.client.agentLabel.required">Agent label is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end forth role -->

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name">
                          Logo -
                          <span style="font-size: 11px">
                            Allowed file type:
                            <b>jpg, jpeg, png</b>
                          </span>
                        </label>
                        <input type="file" ref="file" class="form-control" placeholder="e.g. Dean" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <button style="margin-top: 32px" type="submit" class="btn btn-danger btn-block">Submit</button>
                    </div>
                  </div>
                </form>

                <!-- form end -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import { required, alphaNum, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateClientsAdmin',

  data() {
    return {
      client: {
        // name
        ref: '', // use as short name
        name: '',
        // colors
        primaryColor: '#2C56D8',
        secondaryColor: '#4F27CB',
        // category
        topCategoryLabel: 'Category',
        subCategoryLabel: 'Subcategory',
        // agent and supervisor
        agentLabel: 'Agent',
        supervisorLabel: 'Supervisor'
        //Logo
        //logo: ""
      }
    }
  },

  methods: {
    handleSubmit() {
      let loading = this.$loading.show()
      this.$v.$touch()
      if (this.$v.$invalid) {
        loading.hide()
        return
      }

      let formData = new FormData()
      let allowedExtensions = ['jpg', 'jpeg', 'png']
      let file = this.$refs.file.files[0] //this.$refs.file.files[0]
      formData.append('file', file)
      // Form Validate ...
      let fileName = file.name
      let fileExtension = fileName.replace(/^.*\./, '')
      if (allowedExtensions.includes(fileExtension) == false) {
        let msg = '.' + fileExtension + ' file not allowed. Please replace ' + file.name
        this.$swal('Oops!', msg, 'error')
        loading.hide()
        return
      }
      if (file.size > 200000) {
        let msg = file.name + ' is larger than the allowed file size of 200KB.'
        this.$swal('Oops!', msg, 'error')
        loading.hide()
        return
      }

      formData.append('ref', this.client.ref)
      formData.append('name', this.client.name)
      formData.append('primaryColor', this.client.primaryColor)
      formData.append('secondaryColor', this.client.secondaryColor)
      formData.append('topCategoryLabel', this.client.topCategoryLabel)
      formData.append('subCategoryLabel', this.client.subCategoryLabel)
      formData.append('agentLabel', this.client.agentLabel)
      formData.append('supervisorLabel', this.client.supervisorLabel)

      axios.post('/team/clients/create', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        if (res.data.status == 'success') {
          this.client = {}
          this.$v.$reset()
          this.$swal('Done!', res.data.message, 'success')
          this.$router.push({ name: 'ClientsDetailsAdmin', params: { ref: res.data.client.ref } })
        } else {
          this.$swal('Oops!', res.data.message, 'error')
        }
        loading.hide()
      })
    }
  },

  validations: {
    //name: { required, minLength: minLength(2) }
    client: {
      ref: { required, alphaNum, minLength: minLength(2) },
      name: { required, minLength: minLength(2) },
      // colors
      primaryColor: { required, minLength: minLength(7), maxLength: maxLength(7) },
      secondaryColor: { required, minLength: minLength(7), maxLength: maxLength(7) },
      // category
      topCategoryLabel: { required },
      subCategoryLabel: { required },
      // agent and supervisor
      agentLabel: { required },
      supervisorLabel: { required }
      // logo
      //logo: { required }
    }
  }
}
</script>

<style></style>
